
<template>
   <v-layout row wrap>
      <v-flex :class="listCss">
         <user-survey-list
            :title="title"
            :userId="userId"
            :selectedUserSurveyId="selectedUserSurveyId"
            :mode="mode"
            @userSurveySelected="userSurveySelected"
            @addUserSurvey="addUserSurvey"
            @deleteUserSurvey="deleteUserSurvey">
        </user-survey-list>
      </v-flex>

      <v-flex :class="detailCss">
         <router-view></router-view>
      </v-flex>
   </v-layout>
</template>


<script>
   import UserSurveyList from '@/components/surveys/UserSurveyList'

   export default {

      props: {
         userId: Number,
         baseRoute: String,
         mode: String, // 'patient', 'caregiver'
      },

      components: {
         UserSurveyList: UserSurveyList,
      },

      mounted: async function() {
         await this.$store.dispatch('surveys/GET_SURVEYS')
         // fetch user' surveys in central store: reactivity will update the list view
         this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId)
      },

      data () {
         return {
            selectedUserSurveyId: null,
         }
      },

      computed: {
         title() {
            return this.user ? "Questionnaires de " + this.user.first_name + ' ' + this.user.last_name : ''
         },

         user() {
            return this.$store.state.users[this.userId]
         },


         listCss() {
            //return { xs12: true, sm3: this.selectedMealId, sm4: !this.selectedMealId }
            return { xs12: true, sm4: true }
         },
         detailCss() {
            //return { xs12: true, sm9: this.selectedMealId, sm8: !this.selectedMealId }
            return { xs12: true, sm8: true }
         },
      },

      methods: {
         userSurveySelected (userSurveyId) {
            // make the module selected in UserSurveyList
            this.selectedUserSurveyId = userSurveyId;
            // change route
            this.$router.push(`${this.baseRoute}${userSurveyId}`)
         },
         addUserSurvey: async function(surveyId) {
            await this.$store.dispatch('surveys/POST_USER_SURVEY', { userId: this.userId, surveyId: surveyId })
            this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId)
         },
         deleteUserSurvey: async function(userSurvey) {
            await this.$store.dispatch('surveys/DELETE_USER_SURVEY', userSurvey)
            this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId)
         },
         assignSurveys (assignments) {
            console.log("assign", assignments)
         },
      },
   };
</script>



// WEBPACK FOOTER //
// UserSurveys.vue?554ca75e